import React from 'react';
import { Tooltip } from '@material-ui/core';
import { useTranslations } from '../../store/translations/hooks';
import { TK } from '../../store/translations/translationKeys';
import AppButton from '../../components/AppButton';

export interface CampaignBuilderFooterProps {
    currentStep: number;
    canGoBack: boolean;
    canGoNext: boolean;
    canSave: boolean;
    canDiscard: boolean;
    canSendNow: boolean;
    canPayAndSend: boolean;
    canSendAfterPayment: boolean;
    canViewAnalytics: boolean;
    loading: boolean;
    sendNowTooltip?: string;
    onBack: () => void;
    onNext: () => void;
    onSave: () => void;
    onDiscard: () => void;
    onSendNow: () => void;
    onPayAndSend: () => void;
    onViewAnalytics: () => void;
}

export const CampaignBuilderFooter: React.FC<CampaignBuilderFooterProps> = ({
    currentStep,
    canGoBack,
    canGoNext,
    canSave,
    canDiscard,
    canSendNow,
    canPayAndSend,
    canSendAfterPayment,
    canViewAnalytics,
    loading,
    sendNowTooltip,
    onBack,
    onNext,
    onSave,
    onDiscard,
    onSendNow,
    onPayAndSend,
    onViewAnalytics,
}) => {
    const t = useTranslations();
    const isLastStep = currentStep >= 4;
    const showAnalyticsOnly = isLastStep && canViewAnalytics && !canSendNow && !canPayAndSend && !canSendAfterPayment && !sendNowTooltip;

    return (
        <div style={{ display: 'flex', gap: 'var(--spacer-S)', justifyContent: 'space-between', flexWrap: 'wrap' }}>
            <div style={{ display: 'flex', gap: 'var(--spacer-S)', flexWrap: 'wrap' }}>
                <AppButton color="secondary" outline disabled={!canDiscard || loading} onClick={onDiscard}>
                    {t(TK.discard)}
                </AppButton>
                <AppButton color="success" disabled={!canSave || loading} onClick={onSave}>
                    {t(TK.save)}
                </AppButton>
            </div>
            <div style={{ display: 'flex', gap: 'var(--spacer-S)', flexWrap: 'wrap' }}>
                <AppButton color="secondary" disabled={!canGoBack || loading} onClick={onBack}>
                    {t(TK.back)}
                </AppButton>
                {isLastStep ? (
                    <>
                        {canViewAnalytics && (
                            <AppButton color="info" outline={!showAnalyticsOnly} onClick={onViewAnalytics}>
                                {t(TK.campaignViewAnalytics)}
                            </AppButton>
                        )}
                        {!showAnalyticsOnly && (
                            canPayAndSend ? (
                                <AppButton color="primary" disabled={loading} onClick={onPayAndSend}>
                                    {t(TK.campaignPayButton)}
                                </AppButton>
                            ) : (
                                <Tooltip title={sendNowTooltip || ''} disableHoverListener={!sendNowTooltip} placement="top">
                                    <span>
                                        <AppButton color="primary" disabled={!canSendNow && !canSendAfterPayment || loading} style={{ pointerEvents: (!canSendNow && !canSendAfterPayment) ? 'none' : undefined }} onClick={onSendNow}>
                                            {t(TK.sendNow)}
                                        </AppButton>
                                    </span>
                                </Tooltip>
                            )
                        )}
                    </>
                ) : (
                    <AppButton color="primary" disabled={!canGoNext || loading} onClick={onNext}>
                        {t(TK.next)}
                    </AppButton>
                )}
            </div>
        </div>
    );
};
